import { ChangeEvent, FC } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import RhfCheckboxGroup from 'components/CheckboxGroup/RhfCheckboxGroup/RhfCheckboxGroup';
import {
  SAGITTAL_ACTIONS_OPTIONS,
  SAGITTAL_ACTIONS_VALUES
} from 'constants/prescriptionOptions';
import { Option } from 'types/select';
interface Props {
  fieldName: string;
  isDisabled?: boolean;
}

const SagittalAction: FC<Props> = ({ fieldName, isDisabled }) => {
  const { control } = useFormContext();

  const RemoveMultiCheckedOptions = (
    data: Array<Option>,
    multiCheckOptions: string[],
    e?: ChangeEvent<HTMLInputElement>
  ) => {
    let selectedValue;
    const isAnyMultiCheckOptionChecked =
      multiCheckOptions.includes(e?.target.value || '') && e?.target.checked;
    const isAnyOtherOptionChecked =
      !multiCheckOptions.includes(e?.target.value || '') && e?.target.checked;

    if (isAnyMultiCheckOptionChecked) {
      selectedValue = data.filter((option) =>
        multiCheckOptions.includes(option?.value)
      );
    } else if (isAnyOtherOptionChecked) {
      selectedValue = data.filter(
        (option) => !multiCheckOptions.includes(option?.value || '')
      );
    } else {
      selectedValue = data;
    }
    return selectedValue;
  };
  return (
    <div>
      <Controller
        control={control}
        name={fieldName}
        render={({ field }) => (
          <div className='w-full'>
            <RhfCheckboxGroup
              disabled={isDisabled}
              options={SAGITTAL_ACTIONS_OPTIONS}
              name={fieldName}
              className='mt-1'
              checkBoxItemFont='md:text-17px text-sm flex flex-row space-x-10'
              onChange={(data, name, e) => {
                field.onChange(
                  RemoveMultiCheckedOptions(
                    data,
                    [
                      SAGITTAL_ACTIONS_VALUES.IMPROVE_CANINE_RELATIONSHIP,
                      SAGITTAL_ACTIONS_VALUES.IMPROVE_MOLAR_RELATIONSHIP
                    ],
                    e
                  )
                );
              }}
            />
          </div>
        )}
      />
    </div>
  );
};
export default SagittalAction;
